// export const baseURL = 'http://192.168.1.110:38080'; //测试
export const baseURL = 'http://tzhuangzhuangmanager.test.580travel.com/'; //测试
// export const baseURL = ''; //打包

// export const qiniuImgURL = 'http://upload.qiniu.com'; //七牛云
export const baseImgUrl = 'http://img.580travel.com'; //七牛云



// WEBPACK FOOTER //
// ./src/utils/baseUrl.js